import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { FilterTable } from 'gnos-tables'
import cx from 'classnames'
import _ from 'lodash'
import log from 'loglevel'

import config from '../../../../../../../../../../../../../config'

import { createFilterTableId } from '../../../../../../../../../../helpers'

import { LOCALE_PREFIX } from './constants'

import QuestionIcon from '../../../../../../../../../../../../../components/QuestionIcon'
import DistrictMap from './components/DistrictMap'
import EstateDetail from './components/EstateDetail'

import hocConnect from './hocConnect'

import './style.scss'

@injectIntl
@hocConnect
export default class OwnershipListDetail extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        district: PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
        }),
        id: PropTypes.string.isRequired,
        intl: PropTypes.object.isRequired,
        legalRelationships: PropTypes.arrayOf(PropTypes.string),
        listId: PropTypes.string.isRequired,
        loadDataTable: PropTypes.func.isRequired,
        loadDetailDataTable: PropTypes.func.isRequired,
        openCadastreLink: PropTypes.func.isRequired,
        region: PropTypes.string,
        removeDetailDataTable: PropTypes.func.isRequired,
        saveCustomData: PropTypes.func.isRequired,
        village: PropTypes.string,
    }

    static defaultProps = {
        district: null,
        legalRelationships: [],
        region: null,
        village: null,
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.id !== nextProps.id) return true
        if (this.props.block !== nextProps.block) return true
        if (this.props.listId !== nextProps.listId) return true
        if (this.props.region !== nextProps.region) return true
        if (this.props.village !== nextProps.village) return true
        if (!_.isEqual(this.props.district, nextProps.district)) return true
        if (!_.isEqual(this.props.legalRelationships, nextProps.legalRelationships)) return true
        if (!_.isEqual(this.props.customData, nextProps.customData)) return true

        return false
    }

    // HANDLERS

    onDataTableChange = (tableState) => {
        const { id, listId, loadDataTable } = this.props

        loadDataTable(id, listId, tableState.pagination.page, tableState.pagination.rowsPerPage, tableState.sorted)
    }

    onRowExpanded = (expandedData) => {
        const { id, listId, loadDetailDataTable, removeDetailDataTable } = this.props

        const expand = _.get(expandedData, 'expand', false)
        const objectId = _.get(expandedData, 'rowId', null)

        if (expand) loadDetailDataTable(id, listId, objectId)
        else removeDetailDataTable(id, listId, objectId)
    }

    onTypeCellLinkClick = (_e) => {
        const { id, block, listId, openCadastreLink } = this.props

        _e.stopPropagation()

        // TODO remove log [#42511]
        log.info(`Open cadastre link for id: ${id} block: ${block} listId: ${listId}`)
        // TODO add required params (action and saga need to be updated) [#42511]
        openCadastreLink()
    }

    // RENDER TABLE CELLS

    // TODO uncomment estate link to cadastre [#42511]
    renderTypeCell = (type) => (
        <div className={cx('ownership-list-detail-type-cell', type.id)}>
            <div className={'estate-type'}>{type.name}</div>
            {/* <div className={'estate-link'} onClick={this.onTypeCellLinkClick} /> */}
        </div>
    )

    renderRestrictionsCell = (count) => {
        const { intl } = this.props

        if (count === null) return <div>{'-'}</div>

        const text = intl.formatMessage(
            { id: `${LOCALE_PREFIX}.ownershipListDetail.restrictions.${count > 0 ? 'yes' : 'no'}` },
            { count }
        )

        return <div className={'ownership-list-detail-restrictions-cell'}>{_.toUpper(text)}</div>
    }

    renderCommonValueCell = (value) => <div className={'ownership-list-detail-common-cell'}>{value}</div>

    // MAIN RENDERS

    renderDistrictTooltip = () => {
        const { district } = this.props

        return <DistrictMap districtCode={district.id} scale={0.35} />
    }

    renderSummary = () => {
        const { id, block, listId, village, district, region, intl } = this.props

        return (
            <div className={'summary'}>
                <div className={'summary-title'}>{intl.formatMessage({ id: `${LOCALE_PREFIX}.title` })}</div>
                <div className={'summary-text'}>
                    {village && (
                        <div className={'text-wrap'}>
                            <div className={'key'}>{`${intl.formatMessage({
                                id: `${LOCALE_PREFIX}.title.village`,
                            })}:`}</div>
                            <div className={'value'}>{village}</div>
                        </div>
                    )}
                    {district && (
                        <div className={'text-wrap'}>
                            <div className={'key'}>{`${intl.formatMessage({
                                id: `${LOCALE_PREFIX}.title.district`,
                            })}:`}</div>
                            <div className={'value'}>{district.name}</div>
                            <QuestionIcon
                                id={`${config.modules.report.key}_${id}_${block}_${listId}_question`}
                                color={'#bed02e'}
                                text={this.renderDistrictTooltip()}
                            />
                        </div>
                    )}
                    {region && (
                        <div className={'text-wrap'}>
                            <div className={'key'}>{`${intl.formatMessage({
                                id: `${LOCALE_PREFIX}.title.region`,
                            })}:`}</div>
                            <div className={'value'}>{region}</div>
                        </div>
                    )}
                </div>
            </div>
        )
    }

    renderLegalRelationships = () => {
        const { legalRelationships, intl } = this.props

        if (_.isEmpty(legalRelationships)) return null

        return (
            <div className={'legal-relationships'}>
                <div className={'legal-relationships-title'}>
                    {intl.formatMessage({ id: `${LOCALE_PREFIX}.legalRelationships.title` })}
                </div>
                <div className={'legal-relationships-list'}>
                    {_.map(legalRelationships, (legalRelationship, index) => (
                        <div key={index} className={'legal-relationships-item'}>
                            {legalRelationship}
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    // RENDER ESTATE DETAIL

    renderOwnershipEstateDetail = (subComponentData) => {
        const { id, block, listId, saveCustomData } = this.props

        const rowData = _.get(subComponentData, 'row.original', {})
        const objectId = _.toString(_.get(rowData, subComponentData.itemIdentifier, null))

        return (
            <EstateDetail id={id} block={block} listId={listId} objectId={objectId} saveCustomData={saveCustomData} />
        )
    }

    renderTable = () => {
        const { id, block, listId, customData, intl } = this.props

        const table = _.get(customData, 'table', {})

        const tableData = _.get(table, 'data', [])
        const tableSortAvailableColumns = _.get(table, 'sort.availableColumns', [])
        const tableSortSorted = _.get(table, 'sort.sorted', [])
        const tablePagination = _.get(table, 'pagination', {})

        const tableIsLoading = _.get(customData, 'isLoading', false)

        return (
            <div className={'detail-table'}>
                <FilterTable
                    id={createFilterTableId(config.modules.report.key, id, block, listId)}
                    itemIdentifier={'id'}
                    loading={tableIsLoading}
                    data={tableData}
                    settings={{
                        sorted: tableSortSorted,
                        pagination: tablePagination,
                    }}
                    columnsDefinition={[
                        {
                            accessor: 'type',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.ownershipListDetail.header.type` }),
                            Cell: ({ value }) => this.renderTypeCell(value),
                            sortable: _.includes(tableSortAvailableColumns, 'type'),
                            width: 130,
                        },
                        {
                            accessor: 'identification',
                            Header: intl.formatMessage({
                                id: `${LOCALE_PREFIX}.ownershipListDetail.header.identification`,
                            }),
                            Cell: ({ value }) => this.renderCommonValueCell(value),
                            sortable: _.includes(tableSortAvailableColumns, 'identification'),
                        },
                        {
                            accessor: 'utilization',
                            Header: intl.formatMessage({
                                id: `${LOCALE_PREFIX}.ownershipListDetail.header.utilization`,
                            }),
                            Cell: ({ value }) => this.renderCommonValueCell(value),
                            sortable: _.includes(tableSortAvailableColumns, 'utilization'),
                        },
                        {
                            accessor: 'restrictions',
                            Header: intl.formatMessage({
                                id: `${LOCALE_PREFIX}.ownershipListDetail.header.restrictions`,
                            }),
                            Cell: ({ value }) => this.renderRestrictionsCell(value),
                            sortable: _.includes(tableSortAvailableColumns, 'restrictions'),
                        },
                    ]}
                    SubComponent={this.renderOwnershipEstateDetail}
                    onTableChange={this.onDataTableChange}
                    onExpandedChange={this.onRowExpanded}
                    texts={{
                        pagination: {
                            page: intl.formatMessage({ id: 'global.page' }),
                            from: intl.formatMessage({ id: 'global.of' }),
                            rowCount: intl.formatMessage({ id: 'global.rowCount' }),
                            rowShow: intl.formatMessage({ id: 'global.rowShow' }),
                            all: intl.formatMessage({ id: 'global.all' }),
                        },
                    }}
                    expandOnRowClick
                />
            </div>
        )
    }

    // RENDER MAIN CONTENT

    render() {
        return (
            <div className={'ownership-list-detail'}>
                {this.renderSummary()}
                {this.renderLegalRelationships()}
                {this.renderTable()}
            </div>
        )
    }
}
